import React, { useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import HelperMetiers360 from "../../../../../services/HelpersMetiers360.js";
import useDebounceSearch from "../../../../../hooks/useDebounchSearch.jsx";
import SelectMultipleItemsComponent from '../../../../widgets/selectMultipleItemsComponent/SelectMultipleItemsComponent.jsx';

const Webapp2UsersFilters = ({ users, groups, children, idPrefix = 'default', displaySearchBar = true }) => {
    const [selectedGroups, setSelectedGroups] = useState([]);
    // selectedGroups is an array of group objects (with uniqueId, name) or [{uniqueId: 0}] for "sans groupe"
    const [selectedSessionType, setSelectedSessionType] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [archivedFilter, setArchivedFilter] = useState('active');

    const { searchInput, search } = useDebounceSearch({
        placeholder: 'Rechercher par mots-clés (pseudo, prénom, nom)',
        delay: 400,
    });

    const filteredUsers = users?.filter(user => {
        if (archivedFilter === 'active' && user.isArchived) return false;
        if (archivedFilter === 'archived' && !user.isArchived) return false;

        if (search && !HelperMetiers360.isSearchInText(search, user.userName)
            && !HelperMetiers360.isSearchInText(search, user.firstName)
            && !HelperMetiers360.isSearchInText(search, user.lastName)
            && !HelperMetiers360.isSearchInText(search, user.email)) {
            return false;
        }

        if (selectedGroups.length > 0) {
            const hasNone = selectedGroups.some(g => g.uniqueId === 0);
            const groupIds = selectedGroups.filter(g => g.uniqueId !== 0).map(g => g.uniqueId);
            const matchesNone = hasNone && (!user.webapp2Groups || user.webapp2Groups.length === 0);
            const matchesGroup = groupIds.length > 0 && groupIds.some(id => user.webapp2Groups?.some(g => g.uniqueId === id));
            if (!matchesNone && !matchesGroup) return false;
        }

        if (selectedSessionType) {
            if (selectedSessionType === 'authenticated' && !user.isAuthenticated) return false;
            if (selectedSessionType === 'invited' && user.isAuthenticated) return false;
        }

        if (dateFrom && user.lastActivityAt) {
            const userDate = new Date(user.lastActivityAt);
            const fromDate = new Date(dateFrom);
            if (userDate < fromDate) return false;
        }

        if (dateTo && user.lastActivityAt) {
            const userDate = new Date(user.lastActivityAt);
            const toDate = new Date(dateTo);
            if (userDate > toDate) return false;
        }

        if ((dateFrom || dateTo) && !user.lastActivityAt) return false;

        return true;
    }) ?? [];

    return <>
        {displaySearchBar && searchInput}
        <Row className="my-2 align-items-center justify-content-between">
            {groups?.length > 0 && <Col xs="auto">
                <Form.Group className="d-flex align-items-center gap-2">
                    <Form.Label className="mb-0 fw-bold text-nowrap">Groupes :</Form.Label>
                    <div style={{ minWidth: '180px' }}>
                        <SelectMultipleItemsComponent
                            items={groups}
                            itemsSelected={selectedGroups}
                            setItemsSelected={setSelectedGroups}
                            name="webapp2GroupsFilter"
                            itemKey="uniqueId"
                            itemValue="name"
                            labelNone="groupe"
                        />
                    </div>
                </Form.Group>
            </Col>}
            {/* The filter on user's session type will be implemented later */}
            {/* <Col xs="auto">
                <Form.Group className="d-flex align-items-center gap-2">
                    <Form.Label className="mb-0 fw-bold text-nowrap">Type de session :</Form.Label>
                    <Form.Select size="sm" value={selectedSessionType} onChange={(e) => setSelectedSessionType(e.target.value)}>
                        <option value="">--</option>
                        <option value="authenticated">Authentifiée</option>
                        <option value="invited">Invitée</option>
                    </Form.Select>
                </Form.Group>
            </Col> */}
            <Col xs="auto">
                <Form.Group className="d-flex align-items-center gap-2">
                    <Form.Label className="mb-0 fw-bold text-nowrap">Dernière connexion :</Form.Label>
                    <Form.Control
                        type="datetime-local"
                        size="sm"
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                    />
                    <span>au</span>
                    <Form.Control
                        type="datetime-local"
                        size="sm"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                    />
                </Form.Group>
            </Col>
            <Col xs="auto">
                <Form.Group className="d-flex align-items-center gap-2">
                    <Form.Label className="mb-0 fw-bold text-nowrap">Archivé⋅es :</Form.Label>
                    <Form.Select size="sm" value={archivedFilter} onChange={(e) => setArchivedFilter(e.target.value)}>
                        <option value="all">Tou⋅tes</option>
                        <option value="active">Uniquement non archivé⋅es</option>
                        <option value="archived">Uniquement archivé⋅es</option>
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>
        {children(filteredUsers)}
    </>;
};

Webapp2UsersFilters.propTypes = {
    users: PropTypes.array,
    groups: PropTypes.array,
    children: PropTypes.func.isRequired,
    idPrefix: PropTypes.string,
    displaySearchBar: PropTypes.bool,
};

export default Webapp2UsersFilters;
